export default {
  agentProvider: {
    application: '代理商服务商申请',
    applicationEdit: '代理商服务商修改',
    agent: '代理商',
    agentType: '代理商类型',
    period: '周期',
    bufferPeriod: '缓冲期',
    remark: '备注',
    subscribeRegion: '认购区域',
    totalAmount: '总金额',
    periodEndTime: '周期结束时间',
    pleaseSelectAgent: '请选择代理商',
    pleaseSelectAgentType: '请选择代理商类型',
    pleaseSelectPeriod: '请选择周期',
    pleaseSelectStatus: '请选择状态',
    pleaseEnterAmount: '请输入总金额',
    pleaseEnterBufferPeriod: '请输入缓冲期',
    pleaseEnterShareholdingRatio: '请输入股权比例',
    pleaseEnterRemark: '请输入备注',
    pleaseSelectRegion: '请选择省市区',
    campusId: '代理商ID',
    campusName: '代理商名称',
    districts: '所选区域',
    amount: '提货款总额',
    rechargeAmount: '已付提货款金额',
    goldAmount: '剩余未下单金额',
    retainAmount: '应保留金额',
    openStatusName: '状态',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    orgTypeLabel: '组织类型：',
    pleaseSelectOrgType: '请选择组织类型',
    pleaseSelectOrgLocation: '请选择所在地',
    signTimeLabel: '签约时间：',
    pieceNameLabel: '片区名称：',
    pleaseEnterPieceName: '请输入片区名称',
    createTimeLabel: '创建时间：',
    contractStatusLabel: '合同状态：',
    pleaseSelectContractStatus: '请选择合同状态',
    handStatusLabel: '交接状态：',
    pleaseSelectHandStatus: '请选择交接状态',
    openStatusLabel: '开业状态：',
    pleaseSelectOpenStatus: '请选择开业状态',
    openTimeLabel: '开业时间：',
    pleaseSelectCreator: '请选择创建人',
    pleaseSelectOperator: '请选择操作人',
    chargeStateLabel: '收费状态：',
    pleaseSelectChargeState: '请选择收费状态',
    chargePlanLabel: '收费方案：',
    pleaseSelectChargePlan: '请选择收费方案',
    isFreeMonthLabel: '是否免抽：',
    pleaseSelectIsFreeMonth: '请选择是否免抽',
    freeEndTimeLabel: '免抽结束时间：',
    overallPlannerLabel: '统筹人员：',
    pleaseSelectOverallPlanner: '请选择统筹人员',
    supportStaffLabel: '支持人员：',
    pleaseSelectSupportStaff: '请选择支持人员',
    schoolGradeLabel: '组织星级：',
    pleaseSelectSchoolGrade: '请选择组织星级',
    orignSignMainNameLabel: '主体原始名称：',
    schoolStatusLabel: '组织账号状态：',
    pleaseSelectSchoolStatus: '请选择组织账号状态',
    campusLabelLabel: '组织标签：',
    pleaseSelectCampusLabel: '请选择组织标签',
    participateTypeLabel: '总部leads投放计划：',
    pleaseSelectParticipateType: '请选择总部leads投放计划',
    orgType: '组织类型',
    orgLocation: '组织所在地',
    signTime: '签约时间',
    pieceName: '片区名称',
    supportStaffName: '支持',
    contractStatus: '合同状态',
    handStatus: '交接状态',
    isFreeMonth: '是否免抽',
    freeTime: '免抽时间',
    chargePlan: '收费方案',
    chargeState: '收费状态',
    schoolGrade: '组织星级',
    openStatus: '开业状态',
    actualOpenTime: '开业时间',
    schoolStatus: '组织账号状态',
    participateType: '总部leads投放计划',
    signMainTypeName: '签约类型',
    signMainName: '签约主体名称',
    orignSignMainTypeName: '签约主体原始名称类型',
    orignSignMainName: '签约主体原始名称',
    contactNo: '签约人联系电话',
    idCard: '身份证号',
    address: '签约人联系地址',
    refundStatusName: '退费状态',
    lastUpdateUserName: '最后修改人',
    lastUpdateTime: '最后修改时间',
    createUserName: '创建人',
    createTime: '创建时间',
    orgInfo: '组织信息',
    orgDataReport: '组织资料报表',
    batchAdd: '批量新增',
    quickSearchPlaceholder: '请输入组织ID、组织名称、签约主体名称、身份证',
    quickSearch: '快捷搜索',
    advancedSearch: '高级搜索',
    clearFilter: '清除筛选',
    orgIdCol: '组织ID',
    orgNameCol: '组织名称',
    viewDetail: '查看详情',
    refund: '退费',
    assignCourses: '分配课程',
    areaRelease: '片区释放',
    operatePine: '操作松子',
    closeOrgAccount: '关闭组织账号',
    openOrgAccount: '开启组织账号',
    batchCreateAgentTitle: '批量创建代理商',
    downloadTemplateTip: '如需下载模板，可点击：',
    downloadImportTemplate: '下载导入模板',
    selectFileToImport: '选择需要导入的文件，并开始导入',
    dragOrClickUpload: '将文件拖到此处，或',
    clickUpload: '点击上传',
    importCompleteViewDetail: '导入完成，点击查看',
    importDetail: '导入详情',
    tip: '提示',
    confirmSubmitOrgTip: '确认提交“{signMainTypeName}-{signMainName}”吗？提交后可进行组织信息的完善。',
    confirmCloseOrgAccount: '确认关闭组织账号？',
    confirmOpenOrgAccount: '确认开启组织账号？',
    closeOrgAccountDesc1: '组织账号被关闭后，组织所有员工账号，无法登录"组织运营系统，',
    closeOrgAccountDesc2: '校长端，教师端"，学生账号无法登录学生端。',
    closeReasonLabel: '关闭原因说明：',
    pleaseEnterReason20: '请输入原因（20字以内）',
    openOrgAccountDesc1: '组织账号开启后，组织所有员工账号，恢复正常登录"组织运营系统，',
    openOrgAccountDesc2: '校长端，教师端"，学生账号可正常登录学生端。',
    verifyTip: '验证提示',
    pleaseCheckSms: '请查收{phone}短信',
    pleaseEnterFourDigitCode: '请输入四位数字验证码',
    codeSentSuccess: '验证码发送成功',
    codeSendFailed: '验证码发送失败',
    courseAssignSuccess: '课程分配成功',
    courseAssignFail: '课程分配失败',
    onlyXlsXlsxFormat: '仅支持.xls或.xlsx格式的文件',
    importFail: '导入失败',
    submitSuccess: '提交成功',
    rechargeNo: '流水号',
    rechargeNoLabel: '充值流水',
    pleaseEnterRechargeNo: '请输入充值流水',
    accountType: '账户类型',
    pleaseSelectAccountType: '请选择账户类型',
    payMethod: '充值方式',
    goldAccountRechargeRecord: '金账户充值记录',
    serviceProviderRights: '服务商权益',
    goldAccountExpenseRecord: '金账户消费记录',
    goldAccount: '金账户',
    accountBalance: '账户余额',
    yuan: '元',
    totalPaymentAmount: '提货款总额',
    paidPaymentAmount: '已付提货款金额',
    retainPaymentAmount: '保留货款金额',
    serviceRegion: '服务区域',
    retainBalance: '应保留余额',
    purchaseProduct: '采购商品',
    purchaseQty: '采购数量',
    purchaseAmount: '采购金额',
    goldAccountPayAmount: '金账户支付金额',
    voucherAccountPayAmount: '裂变账户支付金额',
    cashPayAmount: '现金支付金额',
    payMethodLabel: '支付方式',
    lastPayTime: '最后支付时间',
    voucherBonusAccount: '裂变奖金账户',
    payTimeLabel: '支付时间',
    rechargeAmount: '充值金额',
    payTime: '充值时间',
    pleaseSelectAgentLevel: '请选择代理商级别',
    pleaseEnterReceiverName: '请输入收货人姓名',
    pleaseEnterReceiverPhone: '请输入收货人手机号码',
    pleaseEnterReceiverAddress: '请输入收货人地址',
    pleaseEnterDealerId: '请输入经销商ID',
    agentTypeFieldLabel: '代理商类型：',
    agentLevelFieldLabel: '代理商级别：',
    consigneeFieldLabel: '收货人：',
    consigneeMobileFieldLabel: '收货人手机：',
    consigneeAddressFieldLabel: '收货人地址：',
    dispatchRuleFieldLabel: '发货规则：',
    deviceVersionFieldLabel: '设备版本：',
    dealerIdFieldLabel: '经销商ID：',
    pleaseSelectDispatchRule: '请选择发货规则',
    pleaseSelectDeviceVersion: '请选择设备版本',
    pleaseEnterAgentId: '请输入代理商ID',
    pleaseSelectContractType: '请选择合同类型',
    pleaseSelectFileType: '请选择文件类型',
    pleaseSelectCampusNature: '请选择校区性质',
    pleaseEnterCampusName: '请输入校区名称',
    pleaseSelectMaterialType: '请选择资料类型',
    pleaseSelectInvoiceType: '请选择发票类型',
    ke: '所属客服',
    pleaseSelect: '请选择校区',
    all: '全部',
    not: '未签入',
    idle: '空闲',
    busy: '忙碌',
    ing: '通话中',
    adPosition: '广告位置',
    name: '请输入学校名称',
    onShelf: '上架',
    offShelf: '下架',
    tai: '登录页静态图',
    loginFloatWindow: '登录页浮窗',
    bu: '底部浮窗',
    fullscreenPopup: '霸屏弹窗',
    miniProgramHome: '小程序首页',
    miniProgramSquirrelCup: '小程序松鼠杯',
    time: '免抽结束时间：',
    ru: '呼入',
    chu: '呼出',
    di: '所在地：',
    chuangjian: '创建人：',
    pricingPlan: '收费方案：',
    yes: '是',
    ji: '五星级',
    orgTag: '组织标签：',
    zongbu: '总部leads投放计划：',
    jiao: '正式交接',
    free: '免费',
    paid: '收费',
    no: '否',
    normal: '正常',
    closed: '关闭',
    participate: '参与',
    notParticipate: '不参与',
    xuexiaoxueduan: '学校学段',
    xue: '办学性质',
    boardingStatus: '寄宿情况',
    school: '关联校区',
    public: '公办',
    private: '民办',
    international: '国际',
    tizonge: '提货款总额',
    order: '已支付订单总金额',
    equityRatio: '股权比例',
    purchase: '采购单号',
    recharge: '充值方式:',
    caozuo: '操作人',
    pleaseEnter: '请输入充值流水',
    add: '新增',
    textruia: '表单',
    operation: '操作',
    textsuxt: '文件吗',
    textje8x: '文件名',
    textd6a5: '大小',
    text5jw7: '数据的总长度',
    delete: '删除',
    hour: '有时候搜索是本组件自己触发的',
    minhour: '分页的时候',
    houryici: '这时候直接用上一次的参数',
    texts3fo: '文件',
    textjrfo: '下载失败',
    textla8q: '删除成功',
    textl5ao: '删除失败',
    back: '返回',
    textdhve: '签约基础信息',
    textp0hg: '代理商信息',
    textr0jm: '代理商初始账户金额',
    text03wh: '合同基础信息',
    text83nw: '订单信息',
    textnpnc: '校区主体',
    hao: '账号信息',
    text7kqa: '联系人信息',
    text77h0: '校区基础信息',
    textj19e: '教材版本信息',
    textujbu: '校区设备信息',
    textchvw: '定价及系统信息',
    texttdzq: '资料信息',
    textykpz: '组织签约信息',
    textatrk: '组织基础信息',
    textxdk4: '组织详细信息',
    textjqma: '初始金额',
    textjfhw: '合同部门',
    textjku3: '统筹部门',
    textmffo: '新建',
    edit: '编辑',
    preview: '预览',
    textwhr8: '是否开票',
    texthy28: '展开合同信息',
    textmds2: '展开组织信息',
    textb1hd: '校区是否',
    texte1p3: '在灰度校区',
    text5k7q: '开发环境测试用',
    text5ozx: '获取是否开票默认值',
    textjhfo: '获取',
    textjac1: '获取组织正式',
    textkve0: '获取小松鼠组织',
    textaiw3: '获取详细地址',
    texts52f: '获取组织名称',
    textjeun: '获取组织类型',
    textd5or: '展开收起合同信息',
    yi: '返回上一页',
    textmkpt: '签约信息',
    signingEntity: '签约主体',
    texta293: '个人',
    textqrvk: '法人姓名',
    textqrpg: '联系邮箱',
    text0qu2: '签约人联系地址',
    text79cm: '多校查询',
    textcfao: '签约主体变更状态',
    textpsfg: '未变更',
    texthtif: '已变更',
    text8f1k: '变更详情',
    text91mm: '营业执照附件',
    text20hu: '点击查看',
    textfa0i: '是否多校',
    text9hud: '所在地',
    text0fdp: '合同状态',
    textdst0: '是否折扣合同',
    text41xd: '股权金额',
    textpze9: '签约经理',
    textc148: '地级标准',
    signAmount: '签约金额',
    textb7f1: '实收金额',
    texta9pu: '免抽期',
    month: '个月',
    textenfo: '选址人员',
    marketSubsidyFee: '市场补贴费',
    textf1tq: '地级标准说明',
    text739o: '签约片区名称',
    textwjlv: '签约保证金',
    textey7d: '筹备期',
    text61bh: '校区标签',
    textpavs: '合同信息',
    text3pv0: '合同附件',
    textgk5w: '其他文件签署信息',
    download: '下载',
    textgdcv: '发票信息',
    textkwte: '退费信息',
    text89j4: '退费总金额',
    textfib2: '实际退款金额',
    text057g: '退费方式',
    yihour: '第一笔出款时间',
    textuki5: '第几期退款',
    textsosh: '扣款金额',
    text4s0r: '退费原因',
    textxil0: '转换期权',
    textbwlu: '打款状态',
    erhour: '第二笔出款时间',
    texte2qc: '释放状态',
    textx43c: '出款状态',
    text3d6g: '第几期出款',
    textuag3: '出款信息',
    textvj4l: '释放后的校区信息',
    text61e8: '多校查询对话框',
    text03kt: '变更详情对话框',
    campus: '校区',
    textzt0d: '签约主体类型',
    textt5tl: '签约名称',
    textnicu: '变更原因',
    textq8j4: '类型合同',
    text1wvm: '合同名称',
    contractCode: '合同编号',
    text0z7q: '合同金额',
    textvnxs: '合同签约经理',
    creator: '创建人',
    textisrt: '修改人',
    textzc5z: '文件类型',
    text3bk2: '文件用途',
    text744a: '文件签署经理',
    customerName: '客户姓名',
    mobile: '手机号',
    textkg1z: '订单状态',
    textox83: '订单金额',
    text757y: '保证金',
    textiikg: '已收金额',
    texty5vn: '来源',
    text48iv: '发票类型',
    textr252: '发票金额',
    text8lmk: '发票抬头',
    textsgpq: '退费金额',
    texts2wm: '出款金额',
    text5l9n: '释放后的校区',
    settlementAmount: '结算金额',
    textu1rd: '兜底金额',
    textvd7y: '显示身份证详细',
    textvjsy: '签约主题',
    texto62c: '显示联系方式',
    textomko: '附件打开地址',
    textzjva: '签约主体信息',
    text62wo: '片区释放信息',
    text9gt7: '释放后校区信息',
    textla60: '顶部面包屑',
    textmtpl: '大标题',
    textthsl: '组织主体',
    textr61k: '组织',
    textdhsa: '组织性质',
    textdujb: '组织评星',
    textdtnm: '组织详细地址',
    textzgvh: '查看定位',
    textgey9: '支持人员',
    text5l3n: '正式交接',
    textbhjz: '预交接',
    text9ln6: '开业状态',
    textelby: '原因',
    textavtk: '真实姓名',
    text1hmx: '联系方式',
    text6rts: '展开',
    textfwb7: '收起',
    textqtqr: '联系人姓名',
    textzjio: '联系电话',
    textoncj: '招生电话',
    textk7b6: '招生邮箱',
    textf4vr: '组织面积',
    textrpxj: '教室数',
    textlojp: '最多可容纳',
    textu0d7: '房租',
    textfc2o: '装修状态',
    text767v: '未装修',
    textlfac: '装修中',
    textkk3y: '装修完成',
    text4ch9: '电话',
    texto9g2: '开户行',
    text618k: '收货人',
    text8k5h: '收货人联系方式',
    textzm06: '收货地址',
    texta3pj: '公司',
    textcnn5: '账户名',
    textxh2u: '单位名称',
    textrran: '开户银行',
    textos3a: '组织教材版本信息',
    textq675: '组织设备信息',
    textpuci: '电脑',
    text6iyx: '话机',
    text73vu: '打卡机',
    text8f7w: '手写板',
    textd0tr: '摄像头',
    text40sa: '收费',
    textlea8: '收费方案',
    text8655: '定价系数',
    textadyx: '总部在线支付',
    textlnz6: '开通',
    close: '关闭',
    textrnuy: '自动充值扣款比例',
    texth9ug: '商家',
    textxihj: '组织标签',
    textr4ty: '开启小班课',
    textbo6m: '小班课小学原始定价',
    textwsjq: '小班课初中原始定价',
    textzaqr: '小班课高中原始定价',
    textl0oq: '小班课小学定价',
    textu62b: '小班课初中定价',
    text5orh: '小班课高中定价',
    textitua: '开启大班课',
    textcyos: '大班课小学定价',
    text3qnh: '大班课初中定价',
    text699x: '大班课高中定价',
    textwgk1: '总部',
    text6gu8: '投放计划',
    textxg3q: '领取上限',
    day: '每日',
    text1ewz: '附件',
    text08n9: '资料',
    text3hl2: '输出',
    textaq4e: '基础信息',
    textlm5i: '交接信息',
    textwuc5: '组织地址定位',
    text460s: '设备信息',
    textc5i7: '教材版本',
    texte7wu: '资料类型',
    textz96b: '资料名称',
    text6sic: '上传人',
    textsq7r: '组件传递函数',
    text1quf: '查询信息',
    text2dm7: '查询组织主体交接信息',
    textq34k: '查询联系人信息',
    textulvb: '查询组织基础信息',
    textz8kw: '查询定价及系统信息',
    textblng: '查询组织资料',
    text5y1x: '片区信息',
    textyqix: '关键字',
    textpxms: '修改片区',
    textnn3r: '修改校区片区',
    text8017: '奖励比例',
    textpatt: '待定',
    text85yl: '取消订阅',
    text7sbf: '线索信息',
    textl2db: '线索状态',
    textzbos: '介绍代理商信息',
    textctrb: '介绍人',
    textbp5e: '介绍人所在区域',
    textn7fx: '介绍人姓名',
    textgqvh: '介绍人电话',
    texttn6m: '与客户沟通截图',
    textluet: '奖励方式信息',
    text2gmn: '奖励方式',
    textg4a9: '提现代理商',
    textjq5l: '提现代理商名称',
    textxrvp: '提交代理商信息',
    text6sv4: '提交人代理商',
    text8rfe: '提交代理商名称',
    text2r13: '提交人所在区域',
    texttx22: '客户信息',
    text9eht: '客户电话',
    text54zu: '客户所在区域',
    textzb3a: '客户背景信息',
    textdr39: '跟进拓展信息',
    textpe5s: '跟进的拓展姓名',
    texttkfu: '与拓展沟通截图',
    textoryd: '审核信息',
    text3oqz: '审核意见',
    applicationTime: '申请时间',
    submitTime: '提交时间',
    auditTime: '审核时间',
    pleaseSelectLeadStatus: '请选择线索状态',
    introducerAgentId: '介绍代理商ID',
    introducerAgentName: '介绍代理商名称',
    introducerAgentRegion: '介绍代理商所在区域',
    withdrawAgentId: '提现代理商ID',
    pleaseSelectRewardMethod: '请选择奖励方式',
    textxphb: '渠道代申请',
    textoqrs: '查看协议',
    details: '详情',
    texthfj9: '升级弹窗',
    texth9mi: '升级到',
    text8wsx: '升级所需额度',
    text64ye: '当前级别',
    textzsod: '当前可用额度',
    textn4ks: '点击',
    confirm: '确定',
    textlitm: '后提交申请到女娲系统',
    texteair: '只有',
    texts9bh: '级以上经销商',
    textctyl: '才能申请渠道代',
    text2e0n: '您当前的经销商',
    textd2u8: '属于',
    textzmer: '不支持申请',
    textt2ad: '账户变动通知',
    advertName: '广告名称',
    confirmAdvertStatus: '确认',
    auto_1_381101ee: "采购单号1",
    auto_2_2f5d5b8b: "采购商品2",
    auto_3_e6944985: "采购数量3",
    auto_4_117e0685: "采购金额4",
    auto_5_72a6f3c8: "金账户支付金额5",
    auto_6_2263f7d9: "裂变账户支付金额6",
    auto_7_e571c196: "现金支付金额7",
    auto_8_5cc0a006: "支付方式8",
    auto_9_272f0d73: "最后支付时间9",
    auto_10_a40d69ff: "操作人10",
    auto_11_4b30c5c0: "备注11",
    auto_12_d632128e: "代理商12",
    auto_13_d103286a: "代理商名称13",
    auto_14_5c3b120e: "服务区域14",
    auto_15_6ba7cab2: "提货款总额15",
    auto_16_79db4cda: "已付提货款金额16",
    auto_17_236f815d: "应保留余额17",
    auto_18_58acb097: "状态18",
    auto_19_e4e29a3c: "周期19"
  }
}
